import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import { TicketService } from "../../services/ticket.service";
import { ExpenseType } from "./../../model/domain/ExpenseType";

@Component({
  selector: "expense-type",
  templateUrl: "./expense-type.component.html",
  styleUrls: ["./expense-type.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ExpenseTypeComponent implements OnInit, AfterViewInit {
  @Input() expenses: ExpenseType[] = null;
  @Input() readOnly = false;
  @Input() dataCy = "expenseTypeId";
  @Input() name = "expenseTypeId";
  selectedExpenseIdValue: string;
  @Input()
  get selectedExpenseId() {
    return this.selectedExpenseIdValue;
  }
  set selectedExpenseId(val: string) {
    this.selectedExpenseIdValue = val;
    this.selectedExpenseIdChange.emit(val);
  }
  @Output() selectedExpenseIdChange: EventEmitter<string> =
    new EventEmitter<string>();

  constructor(private service: TicketService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    if (this.expenses == null) {
      this.service.ListExpenses().subscribe((b) => {
        this.expenses = b;
      });
    }
  }
}
